// extracted by mini-css-extract-plugin
export default {"container":"AccessPage_container__Hr2oI"};